import * as microsoftTeams from "@microsoft/teams-js";

export const openCalendar = (email: string) => {
  let url = `https://teams.microsoft.com/l/meeting/new?attendees=${email}`;
  return microsoftTeams.app.openLink(url);
};
